import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import JobModal from "./JobModal";
import axiosAPI from "App/services/axios";
import SweetAlert from "react-bootstrap-sweetalert";

const JobModalContainer = ({
  id,
  visible = false,
  setVisible,
  edit = false,
  done,
}) => {
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [errorMore, setErrorMore] = useState(null);

  useEffect(() => {
    if (visible && id) {
      getJob(id);
    }
  }, [id, visible]); // eslint-disable-line

  const getJob = id => {
    setLoading(true);
    axiosAPI
      .get(`/jobs/${id}`)
      .then(result => {
        setJob(result.data || null);
      })
      .catch(error => {
        setVisible(false);
        setErrorMessage(error?.errorMessage || "An unknown error occurred");
        setErrorMore(error?.errorMore || "Something went wrong, please retry");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const addJob = async job => {
    setLoading(true);
    await axiosAPI
      .post("/jobs", job)
      .then(result => {
        setVisible(false);
        done(result.data.id);
      })
      .catch(error => {
        setLoading(false);
        setErrorMessage(
          error?.errorMessage || "An error occurred while adding new job",
        );
        setErrorMore(error?.errorMore || "An unknown server error occurred");
      });
  };

  const editJob = async job => {
    setLoading(true);
    await axiosAPI
      .put(`/jobs/${job.id}`, job)
      .then(result => {
        setVisible(false);
        done();
      })
      .catch(error => {
        setLoading(false);
        setErrorMessage(
          error?.errorMessage || "An error occurred while editing job",
        );
        setErrorMore(error?.errorMore || "An unknown server error occurred");
      });
  };

  return (
    <>
      <SweetAlert
        danger
        onConfirm={() => {
          setErrorMessage(null);
          setErrorMore(null);
        }}
        title="Error"
        show={!!errorMessage}
      >
        {errorMessage}
        {errorMore && (
          <>
            <br />
            <small>{errorMore}</small>
          </>
        )}
      </SweetAlert>
      <JobModal
        visible={visible}
        job={job}
        edit={edit}
        setVisible={setVisible}
        editJob={editJob}
        addJob={addJob}
        loading={loading}
      />
    </>
  );
};

JobModalContainer.propTypes = {
  id: PropTypes.number,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  edit: PropTypes.bool,
  done: PropTypes.func,
};

export default JobModalContainer;
